import { render, staticRenderFns } from "./InvitedUsersItems.vue?vue&type=template&id=67d625bc&scoped=true&"
import script from "./InvitedUsersItems.vue?vue&type=script&lang=js&"
export * from "./InvitedUsersItems.vue?vue&type=script&lang=js&"
import style0 from "./InvitedUsersItems.vue?vue&type=style&index=0&id=67d625bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d625bc",
  null
  
)

export default component.exports